import { useSetDefaultCalendar as _useSetDefaultCalendar } from '@griply/hooks';
import { getDefaultCalendarWrites } from '@griply/services';
import { useUpdateExternalConnectionMutation } from 'shared/hooks/queries/use-update-external-connection-mutation';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

export const useSetDefaultCalendar = () => {
  const { mutate } = useUpdateExternalConnectionMutation();
  const connections = useExternalCalendarConnections();

  return _useSetDefaultCalendar({
    connections,
    buildWrites: getDefaultCalendarWrites,
    mutate,
  });
};
